import { render } from "./CourseCatalogPage.vue?vue&type=template&id=185b297c&scoped=true"
import script from "./CourseCatalogPage.vue?vue&type=script&lang=js"
export * from "./CourseCatalogPage.vue?vue&type=script&lang=js"

import "./CourseCatalogPage.vue?vue&type=style&index=0&id=185b297c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185b297c"]])

export default __exports__